import React, { useEffect } from 'react';
import { StyleSheet, Text, View } from 'react-native';

import {
  useConsumerQuery,
  useInitiateAuthVerificationMutation,
} from 'apollo/queries/autogenerate/hooks';
import { AuthVerificationScope } from 'apollo/queries/autogenerate/schemas';
import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  onNextButtonPress: () => void;
};

const EditUserProfileInstructions = (props: Props) => {
  const { data } = useConsumerQuery({ fetchPolicy: 'cache-only' });
  const [
    initiateAuthVerificationMutation,
  ] = useInitiateAuthVerificationMutation();

  useEffect(() => {
    initiateAuthVerificationMutation({
      variables: {
        scope: AuthVerificationScope.UPDATE_CONSUMER_INFO,
      },
    }).catch((_err) => {});
  }, []);

  return (
    <View style={style.root}>
      <View>
        <Text style={[style.textTitle, style.marginBottom]}>
          登録した携帯電話番号に認証コードを送信しました
        </Text>
        <Text>
          {data?.consumer.phone}に送信された4桁の認証コードを確認してください。
        </Text>
      </View>
      <View>
        <Button
          title="次へ"
          onPress={props.onNextButtonPress}
          style={style.nextButton}
          id="edit-user-profile-instructions-next-button"
        />
      </View>
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'space-between',
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 24,
  },
  marginBottom: {
    marginBottom: 24,
  },
  nextButton: {
    maxWidth: 296,
    alignSelf: 'center',
  },
});

export default EditUserProfileInstructions;
